export default "__VITE_ASSET__f43ceff4__"